import _DialogActions from "@mui/material/DialogActions";
import _OpenInNew from "@mui/icons-material/OpenInNew";
import _DialogContent from "@mui/material/DialogContent";
import _Typography from "@mui/material/Typography";
import _DialogTitle from "@mui/material/DialogTitle";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { defaultEnvironment } from '../../environment';
import { HttpService } from '../../services';
export function CompanyFormDialog({
  Dialog,
  Button,
  currentUser,
  onClose,
  utmSource,
  ...props
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose()
  }, props), /*#__PURE__*/React.createElement(_DialogTitle, null, t('commons.communities.company_dialog.title')), /*#__PURE__*/React.createElement(_DialogContent, null, /*#__PURE__*/React.createElement(_Typography, null, t('commons.communities.company_dialog.description'))), /*#__PURE__*/React.createElement(_DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => onClose(),
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    component: "a",
    endIcon: /*#__PURE__*/React.createElement(_OpenInNew, null),
    href: `${defaultEnvironment.enterpriseUrl}subscription/connect?auth-token=${HttpService.authorizationToken?.substring(HttpService.authorizationToken.indexOf(' ') + 1)}&user-id=${currentUser?.id}${utmSource ? `&utm_source=${utmSource}` : ''}`,
    rel: "noreferrer",
    target: "_blank",
    variant: "contained"
  }, t('commons.communities.company_dialog.actions.create_company'))));
}